import { render, staticRenderFns } from "./mileage.vue?vue&type=template&id=3b13ea60&scoped=true"
import script from "./mileage.vue?vue&type=script&lang=js"
export * from "./mileage.vue?vue&type=script&lang=js"
import style0 from "./mileage.vue?vue&type=style&index=0&id=3b13ea60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13ea60",
  null
  
)

export default component.exports